module.exports = __webpack_public_path__ + "img/Accounting.6cd11306.svg";